import { render } from "./GameButtons.vue?vue&type=template&id=410cb37a"
import script from "./GameButtons.vue?vue&type=script&lang=js"
export * from "./GameButtons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/zekarim/Documents/HEIG/roesti-quiz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__